import React from "react"
import { useIntl } from "react-intl"
import { useHistory } from "react-router-dom"
import { Card as CardContainer } from "@walmart-web/livingdesign-components"
import { banners } from "./banners"
import "./index.scss"
import { logEvent } from "data-tagging"
import { EVENTS, FLOW_TYPES } from "data-tagging/constants"
import { useApplicationContext } from "context/applicationContext"
import Button from "components/Shared/Button"

interface PromotionBannerProps {
	bannerId?: string
}

const PromotionBanner: React.FC<PromotionBannerProps> = ({ bannerId = "" }) => {
	const intl = useIntl()
	const history = useHistory()
	const findItem = banners.find((item) => item.bannerId === bannerId)
	const { image, title, description, url, buttonText } = findItem ?? banners[0]
	const { organizationName } = useApplicationContext()
	const handleClick = () => {
		logEvent({
			eventName: EVENTS.PROMOTIONBANNER,
			flowType: FLOW_TYPES.HOME,
			data: {
				organization: organizationName,
			},
		})
		history.push(url)
	}
	return (
		<CardContainer className="promotion-banner">
			<img className="promotion-banner-image" src={image} />
			<div className="promotion-banner-content">
				<div className="promotion-banner-content-title">
					{intl.formatMessage({ id: title })}
				</div>
				<div className="promotion-banner-content-description">
					{intl.formatMessage({ id: description })}
				</div>
			</div>
			<div className="promotion-banner-button">
				<Button variant="primary" onClick={handleClick}>
					{intl.formatMessage({ id: buttonText })}
				</Button>
			</div>
		</CardContainer>
	)
}

export default PromotionBanner
